import { Box, Button, Flex, Heading, HStack, Text, Tooltip } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { copyToClipboard } from 'utils';

interface Props {
  location: {
    address: string;
    maxSuites: number;
    availableSuites: number[];
    name: string;
  };
}

function Header({ location: { address, maxSuites, availableSuites, name } }: Props) {
  return (
    <Flex h="82" p={4} borderBottom="1px" borderColor="gray.200" align="center">
      <FontAwesomeIcon icon={['fal', 'location-dot']} size="3x" color="#A57EF3" />
      <Box flex={1} px={3}>
        <Flex alignItems="center" mb={1}>
          <Heading as="h5" size="sm">
            {name}
          </Heading>
          <Tooltip hasArrow placement="right" label="Copy to Clipboard">
            <Button
              size="xs"
              variant="ghost"
              color="gray.500"
              onClick={() => copyToClipboard(name)}
            >
              <FontAwesomeIcon icon={['fal', 'clipboard']} size="lg" />
            </Button>
          </Tooltip>
        </Flex>
        <HStack spacing={10} alignItems="">
          <Box>
            <Text fontSize="sm" color="gray.500">
              Max Suites: {maxSuites}
            </Text>
            <Text fontSize="sm" color="gray.500">
              Available Suites: {availableSuites.length}
            </Text>
          </Box>
          <Flex>
            <Text fontSize="sm" color="gray.500">
              Address: {address}
            </Text>
          </Flex>
        </HStack>
      </Box>
      <Button as={Link} to="edit" variant="ghost">
        <FontAwesomeIcon icon={['fal', 'location-pen']} size="lg" />
      </Button>
    </Flex>
  );
}

export default Header;
